import React from 'react';
import { AdsenseProvider } from '@jelly/components';
export function WrapPageElement(_ref) {
  var _data$props, _data$props2;

  var children = _ref.children,
      data = _ref.data;
  var adsenseData = {
    adsense: data === null || data === void 0 ? void 0 : (_data$props = data.props) === null || _data$props === void 0 ? void 0 : _data$props.adsense,
    adsenseMobile: data === null || data === void 0 ? void 0 : (_data$props2 = data.props) === null || _data$props2 === void 0 ? void 0 : _data$props2.adsenseMobile
  };
  return data ? /*#__PURE__*/React.createElement(AdsenseProvider, adsenseData, children) : children;
}